<div class="content">

  <div class="text-left mt-5">

    <h3>Authenticate and Connect to cloud storage</h3> <br>

    <p>If your files are in cloud storage like <b>Oracle cloud object storage, AWS S3, Dropbox
        or Google Drive</b>, you need to call this api. If you are going to use file from your local
      drive then this step is not required.</p>

    <p>In this example, we will see how we can connect to <b>OCI object storage</b></p><br><br>

    <h5>Example Request</h5><br>

    <div class="card text-bg-dark mb-3">
      <div class="card-body">

        <div class="card-title">
          <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
            <i class="fa fa-clipboard" aria-hidden="true"></i>
          </button>
            
          <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
            Copied <i class="fa fa-check" aria-hidden="true"></i>
          </button>
    
         </div><br><br>
         
        <pre><code >{{ requestData }}</code></pre>
      </div>
    </div> <br><br>


    <h5>Example Response</h5><br>
    
    <div class="card text-bg-light mb-3">
      <div class="card-body">

        <div class="panel panel-primary">
          <div class="tab-menu-heading">
            <ul class="nav nav-pills" role="tablist">
              <!-- Tab menu items -->
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="tab1" data-bs-toggle="tab" data-bs-target="#content1" type="button"
                  role="tab" aria-controls="content1" aria-selected="true">200</button>
              </li>
            </ul>
          </div>

          <div class="panel-body tabs-menu-body mt-4">
            <div class="tab-content">
              <!-- Tab content -->
              <div class="tab-pane fade show active" id="content1" role="tabpanel" aria-labelledby="tab1">
                <div class="card-body">
                  <pre><code [innerHTML]="responseData" ></code></pre>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


    <h3>API doc link:</h3><br>


    <ul>

      <li>
        <a routerLink="/apilist/storage-connect" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Storage Connect</h5>
        </a>
      </li>

      <!-- <li>
        <a routerLink="/apilist/S3Auth" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> S3 Auth</h5>
        </a>
      </li>

      <li>
        <a routerLink="/apilist/dropboxAuth" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Dropbox Auth</h5>
        </a>
      </li>

      <li>
        <a routerLink="/apilist/googledriveAuth" target="_blank">
          <h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Google Drive Auth</h5>
        </a>
      </li> -->


    </ul>



    <!-- <p><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/
            oci-auth"> http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/
        oci-auth</a></p><br> -->

    <!-- <p>Similarly you can connect to <b>other cloud storage</b> like</p><br> -->


    <!-- <div class="table-responsive">

      <table class="table table-light table-hover">
        <thead>
          <tr>
            <th scope="col">No</th>
            <th scope="col">Cloud storage</th>
            <th scope="col">Link</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">1</th>
            <td>S3</td>
            <td><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/s3-auth">
                http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/s3-auth
              </a></td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>Dropbox</td>
            <td><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/dropbox-auth">
                http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/dropbox-auth
              </a></td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>Google Drive</td>
            <td><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/drive-auth">
                http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/drive-auth
              </a></td>
          </tr>
        </tbody>
      </table>

    </div> -->

  </div>


</div>